// @ts-nocheck
import React from 'react';
import EventManagementScorekeepers from '@/pages/admin/event-management/EventManagementScorekeepers';

const DemoScorekeepers: React.FC = () => {
  return <EventManagementScorekeepers />;
};

export default DemoScorekeepers;
